module.exports = __webpack_public_path__ + "static/media/go-logo.b9c6dd84.svg";